// api.js

import axiosInstance from "../axiosInstance";

export const tmsWebhookService = {
  create: async (data, config_id) => {
    try {
      let response = await axiosInstance.post(
        `/tms-webhook?config_id=${config_id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (config_id) => {
    try {
      let response = await axiosInstance.get(
        `/tms-webhook?config_id=${config_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (data, id, config_id) => {
    try {
      let response = await axiosInstance.patch(
        `/tms-webhook/${id}?config_id=${config_id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id, config_id) => {
    try {
      let response = await axiosInstance.delete(
        `/tms-webhook/${id}?config_id=${config_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
